import { render, staticRenderFns } from "./TenantForm.vue?vue&type=template&id=6028d39b&scoped=true&"
import script from "./TenantForm.vue?vue&type=script&lang=js&"
export * from "./TenantForm.vue?vue&type=script&lang=js&"
import style0 from "./TenantForm.vue?vue&type=style&index=0&id=6028d39b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028d39b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VContainer,VForm,VTextField})
